'use strict';

define('templates', [
  'hbs!app/templates/form',
  'hbs!app/templates/fieldset',
  'hbs!app/templates/textfield',
  'hbs!app/templates/textarea',
  'hbs!app/templates/checkbox',
  'hbs!app/templates/select',
  'hbs!app/templates/span',
  'hbs!app/templates/radios',
  'hbs!app/templates/amount',
  'hbs!app/templates/contribution',
  'hbs!app/templates/payment_information',
  'hbs!app/templates/credit_card',
  'hbs!app/templates/cc_expiration',
  'hbs!app/templates/cvv2',
  'hbs!app/templates/date',
  'hbs!app/templates/ticketing',
  'hbs!app/templates/ticketing_level',
  'hbs!app/templates/ticket_holder',
  'hbs!app/templates/guest_collection',
  'hbs!app/templates/inline_error',
  'hbs!app/templates/datalist',
  'hbs!app/templates/captcha',
  'hbs!app/templates/targets',
  'hbs!app/templates/target_select',
  'hbs!app/templates/advocacy_tweet',
  'hbs!app/templates/recaptcha_grid',
  'hbs!app/templates/tribute_gift',
  'hbs!app/templates/recipient_information',
  'hbs!app/templates/question',
  'hbs!app/templates/ecards',
  'hbs!app/templates/premium_gifts',
  'hbs!app/templates/shipping_information',
  'hbs!app/templates/page_alert',
  'hbs!app/templates/checkbox_list_manager',
  'hbs!app/templates/time',
  'hbs!app/templates/international_phone',
  'hbs!app/templates/signature_pad',
  'hbs!app/templates/payment_method',
  'hbs!app/templates/match_pro_input'
], function (form, fieldset, textfield, textarea, checkbox, select, span, radios,
  amount, contribution, payment_information, credit_card, cc_expiration, cvv2,
  date, ticketing, ticketing_level, ticket_holder, guest_collection, inline_error, datalist, captcha, targets,
  target_select, advocacy_tweet, recaptcha_grid, tribute_gift, recipient_information, question,
  ecards, premium_gifts, shipping_information, page_alert, checkbox_list_manager, time, international_phone, signature_pad, payment_method, match_pro_input){
  return {
    form                         : form,
    fieldset                     : fieldset,
    textfield                    : textfield,
    textarea                     : textarea,
    checkbox                     : checkbox,
    radios                       : radios,
    select                       : select,
    span                         : span,
    date                         : date,
    contribution                 : contribution,
    amount                       : amount,
    payment_information          : payment_information,
    credit_card                  : credit_card,
    cc_expiration                : cc_expiration,
    cvv2                         : cvv2,
    ticketing                    : ticketing,
    ticketing_level              : ticketing_level,
    ticket_holder                : ticket_holder,
    guest_collection             : guest_collection,
    captcha                      : captcha,
    targets                      : targets,
    target_select                : target_select,
    advocacy_tweet               : advocacy_tweet,
    recaptcha_grid               : recaptcha_grid,
    question                     : question,
    datalist                     : datalist,
    inline_error                 : inline_error,
    NAME                         : 'minimal',
    tribute_gift                 : tribute_gift,
    recipient_information        : recipient_information,
    ecards                       : ecards,
    premium_gifts                : premium_gifts,
    shipping_information         : shipping_information,
    page_alert                   : page_alert,
    checkbox_list_manager        : checkbox_list_manager,
    time                         : time,
    international_phone          : international_phone,
    cover_costs_checkbox         : checkbox,
    signature_pad                : signature_pad,
    payment_method               : payment_method,
    match_pro_input              : match_pro_input
};
});

